<script setup lang="ts">
import { computed } from 'vue'
import MediumModel from '@/components/Interface/Modal/ModelSizes/MediumModel.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { useGameStore } from '@/stores/gameStore'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()

const error = computed(() => gameStore.modalData)

const tryAgain = () => {
  gameStore.modalType = ''
  window.location.reload()
}

const closeModal = () => {
  gameStore.modalType = ''
}
</script>

<template>
  <MediumModel :title="t('modals.webglError.title')">
    <StandardCard class="p-2" top-padding="0" bottom-padding="0">
      <div class="mb-4">
        <p>{{ t('modals.webglError.description1') }}</p>
        <p class="mt-2 text-sm text-red-500">{{ error }}</p>
      </div>
      <div class="mb-4">
        <p>{{ t('modals.webglError.description2') }}</p>
        <p>{{ t('modals.webglError.description3') }}</p>
        <p class="mt-2 text-sm text-red-500">{{ error }}</p>
      </div>
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <ActionButton @click="tryAgain" color="blue">
          {{ t('modals.webglError.tryAgain') }}
        </ActionButton>
        <ActionButton @click="closeModal" color="gray">
          {{ t('modals.webglError.continueWithoutMap') }}
        </ActionButton>
      </div>
    </StandardCard>
  </MediumModel>
</template>